import OapImmersiveBeforeAfterVideo from './code/Scripts/components/OapImmersiveBeforeAfterVideo.vue';

export default {
  components: {
    OapImmersiveBeforeAfterVideo,
  },
};
